class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = true;
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setOriginalHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      setTimeout(() => {
        document.documentElement.style.setProperty('--header-topscreen', `${this.header.getBoundingClientRect().top}px`);
      }, 50);
    }

    setOriginalHeaderHeight() {
      document.documentElement.style.setProperty('--original-header-height', `${this.header.offsetHeight}px`);
    }

    setBackHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', 'var(--original-header-height)');
      setTimeout(() => {
        document.documentElement.style.setProperty('--header-topscreen', `${this.header.getBoundingClientRect().top}px`);
      }, 50);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled');
        this.setHeaderHeight();
        if (this.preventHide) return;
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled');
        this.setHeaderHeight();
        if (!this.preventReveal) {
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled');
        this.setBackHeaderHeight();
      }

      this.currentScrollTop = scrollTop;
    }
  }

  customElements.define('sticky-header', StickyHeader);
  